export default class JSONStorage
  constructor: (@storage) ->

  read:         -> @storage.data and JSON.parse(@storage.data)
  write: (data) -> @storage.data = JSON.stringify(data)
  clear:        -> delete @storage.data
  isFilled:     -> @storage.data?
  isEmpty:      -> not @isFilled()
